module.exports = __webpack_public_path__ + "img/foto1.f4c5cba7.jpg";